import { Fragment } from 'react';

interface OnboardingProgressProps {
  steps: Array<{ label: string }>;
  currentStep: number;
  totalSteps: number;
}

/** Numbered step indicator across the top of the onboarding card. */
export const OnboardingProgress = ({
  steps,
  currentStep,
  totalSteps,
}: OnboardingProgressProps) => (
  <div className="mb-8">
    <div className="flex items-start">
      {steps.map((s, idx) => {
        const step = idx + 1;
        const isLast = step === totalSteps;
        return (
          <Fragment key={step}>
            <div className="flex flex-col items-center flex-shrink-0">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold transition-colors ${
                  step === currentStep
                    ? 'bg-primary-600 text-white'
                    : step < currentStep
                    ? 'bg-primary-100 text-primary-600'
                    : 'bg-gray-200 text-gray-500'
                }`}
              >
                {step}
              </div>
              <span
                className={`mt-2 text-sm whitespace-nowrap text-center ${
                  currentStep === step ? 'text-primary-600 font-medium' : 'text-gray-500'
                }`}
              >
                {s.label}
              </span>
            </div>
            {!isLast && (
              <div
                className={`flex-1 h-1 mx-2 mt-[18px] transition-colors ${
                  step < currentStep ? 'bg-primary-600' : 'bg-gray-200'
                }`}
              />
            )}
          </Fragment>
        );
      })}
    </div>
  </div>
);
